// slices/searchSlice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  query: "",
  filter: "",
};

const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setSearchQuery: (state, action) => {
      state.query = action.payload;
    },
    setFilter: (state, action) => {
      state.filter = action.payload;
    },
    clearSearch: (state) => {
      state.query = "";
      state.filter = "";
    },
  },
});

export const { setSearchQuery, setFilter, clearSearch } = searchSlice.actions;

export default searchSlice.reducer;
